import type { RootState } from '@app/types';

import { Platform } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const generateDownloadDataStoreStateExportConfig = (
    overwrite?: Partial<RootState['downloadData']['exportConfig']>,
): Exclude<RootState['downloadData']['exportConfig'], undefined> => ({
    replaceLineBreaks: {},
    exportFormat: Platform.ios,
    fileFormat: 10,
    switchIncludeAll: false,
    directoryPrefix: '%LANG_ISO%.lproj/',
    javaPropertiesEncoding: 'utf-8',
    includeTags: '',
    excludeTags: '',
    filterFilenames: [],
    exportEmpty: 'empty',
    exportNullAs: 'empty',
    exportSort: 'a_z',
    javaPropertiesSeparator: 'auto',
    pluralFormat: 0,
    switchIcuNumeric: false,
    placeholderFormat: 1,
    switchEscapePercent: false,
    indentation: 2,
    switchWebhooks: false,
    switchCompact: false,
    switchIncludeDescription: false,
    switchIncludeComments: false,
    switchNoLanguageFolders: false,
    switchDisableReferences: false,
    switchYamlIncludeRoot: true,
    jsonUnescapedSlashes: false,
    addNewlineEof: false,
    exportAll: true,
    exportGuntranslated: false,
    exportGtranslated: false,
    exportGproofread: false,
    exportGlastReviewed: false,
    exportGnonfuzzy: false,
    exportGnonhidden: false,
    triggersAmazons3: false,
    triggersGcs: false,
    triggersGithub: false,
    triggersGithubEnterprise: false,
    triggersGitlab: false,
    triggersBitbucket: false,
    triggersBitbucketEnterprise: false,
    triggersAzure: false,
    filterRepositories: '',
    commitTemplate: '',
    customTranslationStatusIds: [],
    zipStructure: '',
    switchSourceFilenames: false,
    exportPids: [],
    exportLangs: ['640', '602', '673', '666', '766', '643', '10001', '909'],
    iosDirectoryPrefix: '%LANG_ISO%.lproj',
    androidDirectoryPrefix: 'values-%LANG_ISO%/',
    webDirectoryPrefix: '%LANG_ISO%/',
    otherDirectoryPrefix: '%LANG_ISO%/',
    resxDirectoryPrefix: '%LANG_ISO%/',
    arbDirectoryPrefix: '%LANG_ISO%/',
    reactNativeDirectoryPrefix: '%LANG_ISO%/',
    iosZipStructure: '%LANG_ISO%.lproj/Localizable.%FORMAT%',
    androidZipStructure: 'values-%LANG_ISO%/strings.%FORMAT%',
    webZipStructure: 'locale/%LANG_ISO%.%FORMAT%',
    otherZipStructure: '%PROJECT_NAME%-%LANG_ISO%.%FORMAT%',
    reactNativeStructure: 'locale/%LANG_ISO%.%FORMAT%',
    resxStructure: '%PROJECT_NAME%.%LANG_ISO%.%FORMAT%',
    arbStructure: 'locale/%LANG_ISO%.%FORMAT%',
    webhooks: [],
    filenamesCustom: false,
    filenamesOriginal: false,
    customIsoCodes: {
        10: {
            640: 'en_custom_iso',
        },
    },
    defaultBitbucketReviewers: false,
    ...overwrite,
});
